<template>
  <div>
    <el-alert type="info" :closable="false" v-if="showBuild && question" style="margin-bottom: 10px;">
      <pre style="padding: 0;margin: 0;font-size: 16px; white-space: pre-wrap;">{{question}}</pre>
    </el-alert>
    <el-table ref="multipleTable" :data="tableData" border style="width: 100%">
      <el-table-column prop="question" class-name="table-pre-wrap" label="提问"></el-table-column>
      <el-table-column prop="answer" class-name="table-pre-wrap" label="回答"></el-table-column>
      <el-table-column prop="updated_at" label="修改时间" width="160px"></el-table-column>
      <el-table-column label="状态" width="100">
        <template v-slot="{row}">
          <el-dropdown @command="handleCheckCommand(row, $event)">
            <span class="el-dropdown-link cursor-pointer">
              <span v-if="row.deleted" class="text-mute">已归档</span>
              <span v-else-if="row.status===0">待回答</span>
              <span v-else-if="row.status===1">待审核</span>
              <span v-else-if="row.status===2" class="text-success">通过</span>
              <span v-else-if="row.status===3" class="text-danger">不通过</span>
              <span v-if="row.status<0">正在生成 <i class="el-icon-loading"></i></span>
              <i v-else class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">待审核</el-dropdown-item>
              <el-dropdown-item command="2" v-if="row.status > 0">通过</el-dropdown-item>
              <el-dropdown-item command="3" v-if="row.status > 0">不通过</el-dropdown-item>
              <el-dropdown-item command="-1">重新生成</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        v-if="total>pageSize"
    >
    </el-pagination>
  </div>
</template>

<script>
// import ExerciseQaForm from './ExerciseQaForm'
// import ExercisePreview from './ExercisePreview'
import table from './../mixins/table.js'
// import ListSearchForm from './ListSearchForm'

export default {
  name: 'ExerciseQaHistory',
  props: {
    exr_id: [String, Number],
    code: String,
    lang: String,
    showBuild: Boolean
  },
  mixins: [table],
  data() {
    return {
      multipleSelection: [],
      dialogTitle: '添加题目',
      dialogVisible: false,
      batchVisible: false,
      fetchUrl: 'exercise_qa_history',
      showWordDialog: false,
      showWordModel: null,
      sort: null,
      status: null,
      question: null
    }
  },
  watch: {
    exr_id() {
      this.fetchData();
      this.loadQuestion();
    },
    code() {
      this.fetchData();
    },
    lang() {
      this.fetchData();
    }
  },
  created() {
    this.loadQuestion();
  },
  methods: {
    handleFetchConfig(config) {
      Object.assign(config.params, {
        'filter[status]': null,
        exr_id: this.exr_id,
        code: this.code,
        qalang: this.lang,
      })
    },
    handleBuild() {
      this.$http.post(this.$urls.exercise_qa_build, {}, {
        params: {exr_id: this.exr_id}
      }).then((res) => {
        this.reload();
      })
    },
    rebuildModel(item) {
      this.$http.put(this.$urls.exercise_qa_rebuild, {}, {
        params: {id: item.id}
      }).then((res) => {
        this.reload();
      })
    },
    handleCheckCommand(item, command) {
      const status = Number.parseInt(command);
      if (status < 0) {
        item.status = status;
        this.rebuildModel(item);
      } else {
        return this.$http.put(this.$urls.exercise_qa_update, {
          status,
          deleted: item.deleted ? 0 : undefined
        }, {
          params: {id: item.id}
        }).then(this.reload)
      }
    },
    reload() {
      this.fetchData();
      this.$emit('change');
    },
    loadQuestion() {
      this.question = null;
      if (this.exr_id) {
        this.$http.get(this.$urls.exercise_qa_question, {
          params: {id: this.exr_id}
        }).then(res => {
          this.question = res.data ? res.data.question : null;
        })
      }
    }
  }
}
</script>